/* eslint-disable radix */
/* eslint-disable arrow-body-style */
/* eslint-disable no-return-assign */
/* eslint-disable no-case-declarations */
import { Reducer } from 'redux';
import { OrderState, OrderTypes, Product } from './types';
import {
  updateOrderProductAvailability,
  getVariationItemsUpdated,
  updateOrderVariationItemAvailability,
  updateOrderProductCurrentStock,
  updateOrderVariationItemStock,
  getVariationItemsStockUpdated,
  updateOrderProductStock,
} from '../../../services/functions';

// const currentMerchantUrlCode = () => {
//   const URI = window.location.pathname.substring(1).split('/')[0];
//   return URI;
// };

// const URI = currentMerchantUrlCode();

// console.log('Requisição: ', JSON.parse(localStorage.getItem(`cart_${URI}`) || '[]'));

export const INITIAL_STATE: OrderState = {
  merchantId: '',
  //@ts-ignore
  customer: {
    name: '',
    email: '',
    cpf: '',
    phoneDdd: '',
    phoneNumber: '',
  },
  //@ts-ignore
  delivery: {
    method: '',
    address: {
      street: '',
      streetNumber: '',
      complement: '',
      neighborhood: '',
      city: '',
      cityCode: '',
      state: '',
      country: '',
      postalCode: '',
      reference: '',
      latitude: 0,
      longitude: 0,
    },
    ship: {
      companyName: '',
      deliveryFee: 0,
      deliveryTime: 0,
      serviceCode: 0,
      serviceName: '',
    },
  },
  observation: '',
  items: [],
  subtotal: 0,
  deliveryFee: 0,
  total: 0,
  payments: [],
};

const reducer: Reducer<OrderState> = (state = INITIAL_STATE, action) => {
  switch (action.type) {
    case OrderTypes.LOAD_ORDER:
      return state;

    case OrderTypes.UPDATE_ORDER_SHIP:
      const service = { ...state };
      service.deliveryFee = action.data.deliveryFee;
      service.delivery.ship = action.data;
      // console.log('Transport: action.data', action.data);
      // console.log('Transport: service', service);
      return state;

    case OrderTypes.UPDATE_ORDER:
      const updatedOrder = state;
      updatedOrder.items = action.data.filter(
        (item: Product) => item.quantity > 0,
      );
      updatedOrder.subtotal = updatedOrder.items.reduce(
        (subtotal: number, product: Product) => subtotal + product.total,
        0,
      );
      return { ...state, ...updatedOrder };

    case OrderTypes.UPDATE_ORDER_PRODUCT:
      const updatedCart = state;
      const variationsTotal = +action.data.variationsTotal.toFixed(12);
      const UPDATE_PRODUCTS_URI = window.location.pathname
        .substring(1)
        .split('/')[0];
      if (action.quantity >= 1) {
        updatedCart.items[action.index] = {
          ...action.data,
          quantity: action.quantity,
          observations: action.observations,
          subtotal: action.data.price + variationsTotal,
          total: action.quantity * (action.data.price + variationsTotal),
        };
      } else {
        updatedCart.items.splice(action.index, 1);
      }

      updatedCart.subtotal = updatedCart.items.reduce(
        (subtotal: number, product: Product) => subtotal + product.total,
        0,
      );
      localStorage.setItem(
        `products_${UPDATE_PRODUCTS_URI}`,
        JSON.stringify(updatedCart.items),
      );
      return { ...state, ...updatedCart };

    case OrderTypes.UPDATE_ORDER_PRODUCT_AVAILABILITY:
      if (action.data.merchantId === state.merchantId) {
        const UPDATE_PRODUCTS_AVAILABILITY_URI = window.location.pathname
          .substring(1)
          .split('/')[0];
        updateOrderProductAvailability(
          `products_${UPDATE_PRODUCTS_AVAILABILITY_URI}`,
          action.data.productId,
          action.data.availability,
        );
        return {
          ...state,
          items: state.items.map((item: Product) => {
            return item.productId === action.data.productId
              ? {
                  ...item,
                  availability: action.data.availability,
                }
              : item;
          }),
        };
      }
      return state;

    case OrderTypes.UPDATE_ORDER_PRODUCT_AVAILABILITY_BY_CATEGORY_ID:
      if (action.data.merchantId === state.merchantId) {
        return {
          ...state,
          items: state.items.map((item: Product) => {
            return item.categoryId === action.data.categoryId
              ? {
                  ...item,
                  availability: action.data.availability,
                }
              : item;
          }),
        };
      }
      return state;

    case OrderTypes.UPDATE_ORDER_VARIATION_ITEM_AVAILABILITY:
      if (action.data.merchantId === state.merchantId) {
        const UPDATE_VARIATION_AVAILABILITY_URI = window.location.pathname
          .substring(1)
          .split('/')[0];
        updateOrderVariationItemAvailability(
          `products_${UPDATE_VARIATION_AVAILABILITY_URI}`,
          action.data.variationId,
          action.data.variationItemId,
          action.data.availability,
        );
        return {
          ...state,
          items: state.items.map((item: Product) => {
            return {
              ...item,
              variations: getVariationItemsUpdated(
                item.variations,
                action.data.variationId,
                action.data.variationItemId,
                action.data.availability,
              ),
            };
          }),
        };
      }
      return state;

    case OrderTypes.UPDATE_ORDER_VARIATION_ITEM_STOCK:
      if (action.data.merchantId === state.merchantId) {
        const UPDATE_VARIATION_STOCK_URI = window.location.pathname
          .substring(1)
          .split('/')[0];
        updateOrderVariationItemStock(
          `products_${UPDATE_VARIATION_STOCK_URI}`,
          action.data.variationId,
          action.data.variationItemId,
          parseInt(action.data.stock),
        );
        return {
          ...state,
          items: state.items.map((item: Product) => {
            return {
              ...item,
              variations: getVariationItemsStockUpdated(
                item.variations,
                action.data.variationId,
                action.data.variationItemId,
                parseInt(action.data.stock),
              ),
            };
          }),
        };
      }
      return state;

    case OrderTypes.UPDATE_ORDER_PRODUCT_CURRENT_STOCK:
      if (action.data.merchantId === state.merchantId) {
        const UPDATE_CURRENT_STOCK_URI = window.location.pathname
          .substring(1)
          .split('/')[0];
        updateOrderProductCurrentStock(
          `products_${UPDATE_CURRENT_STOCK_URI}`,
          action.data.productId,
          parseInt(action.data.stock),
        );
        return {
          ...state,
          items: state.items.map((item: Product) => {
            return item.productId === action.data.productId
              ? {
                  ...item,
                  stock: {
                    ...item.stock,
                    current: parseInt(action.data.stock),
                  },
                }
              : item;
          }),
        };
      }
      return state;

    case OrderTypes.UPDATE_ORDER_PRODUCT_STOCK:
      if (action.data.merchantId === state.merchantId) {
        const UPDATE_STOCK_URI = window.location.pathname
          .substring(1)
          .split('/')[0];
        const product: Product = JSON.parse(action.data.data);
        updateOrderProductStock(
          `products_${UPDATE_STOCK_URI}`,
          action.data.productId,
          product.stock,
        );
        return {
          ...state,
          items: state.items.map((item: Product) => {
            return item.productId === action.data.productId
              ? {
                  ...item,
                  stock: {
                    ...item.stock,
                    orderMax: product.stock.orderMax,
                  },
                }
              : item;
          }),
        };
      }
      return state;

    case OrderTypes.INSERT_ORDER_PRODUCT:
      const cartItem = {
        ...state,
      };

      const INSERT_URI = window.location.pathname.substring(1).split('/')[0];

      if (cartItem.items[0] === undefined) {
        cartItem.items[0] = action.data;
        cartItem.subtotal = cartItem.items.reduce(
          (subtotal: number, product: Product) => subtotal + product.total,
          0,
        );
        localStorage.setItem(
          `products_${INSERT_URI}`,
          JSON.stringify(cartItem.items),
        );
        return { ...state, ...cartItem };
      }
      cartItem.items.push(action.data);

      cartItem.subtotal = cartItem.items.reduce(
        (subtotal: number, product: Product) => subtotal + product.total,
        0,
      );

      localStorage.setItem(
        `products_${INSERT_URI}`,
        JSON.stringify(cartItem.items),
      );
      return { ...state, ...cartItem };

    case OrderTypes.UPDATE_CUSTOMER_ADDRESS:
      const updatedAddress = { ...state };
      updatedAddress.delivery.address = action.data;
      updatedAddress.delivery.method = action.method;
      localStorage.setItem(
        'meucarrinhoAddress',
        JSON.stringify(updatedAddress.delivery),
      );
      return {
        ...state,
        ...updatedAddress,
      };

    case OrderTypes.UPDATE_DELIVERY_FEE:
      return {
        ...state,
        deliveryFee: action.data,
      };

    case OrderTypes.UPDATE_MERCHANT_ID:
      return {
        ...state,
        merchantId: action.data,
      };

    case OrderTypes.UPDATE_TOTAL:
      const total = state;

      total.subtotal = Number(total.subtotal.toFixed(2));

      total.total = +(total.subtotal + total.deliveryFee).toFixed(12);

      total.items = total.items.map(
        (product: Product, index: number) =>
          (total.items[index] = { ...product, item: index + 1 }),
      );
      return { ...state, ...total };

    case OrderTypes.UPDATE_CUSTOMER_INFOS:
      return {
        ...state,
        customer: action.data,
      };

    case OrderTypes.UPDATE_CUSTOMER_PAYMENT:
      return {
        ...state,
        payments: action.data,
      };

    case OrderTypes.UPDATE_OBSERVATION:
      return {
        ...state,
        observation: action.data,
      };

    case OrderTypes.CLEAR_CART:
      const renewCart = state;

      // const M_URL = window.location.pathname.substring(1).split('/')[0];

      const CLEAR_CART_URI = window.location.pathname
        .substring(1)
        .split('/')[0];

      localStorage.removeItem(`products_${CLEAR_CART_URI}`);

      if(renewCart.delivery.method === 'SHIP'){
        renewCart.deliveryFee = 0;
      }
      renewCart.items = [];
      renewCart.total = 0;
      renewCart.subtotal = 0;
      renewCart.observation = '';
      renewCart.payments = [];

      return {
        ...state,
        ...renewCart,
      };

    default:
      return state;
  }
};

export default reducer;
